'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'whistle';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f460';
var svgPathData = 'M93.4 115.3C79.5 128.1 67.6 143 58 159.4c-14.8-2.8-26-15.8-26-31.4c0-17.7 14.3-32 32-32c13.2 0 24.5 7.9 29.4 19.3zM0 128c0 28.4 18.5 52.5 44.1 60.8C36.3 209.7 32 232.4 32 256c0 106 86 192 192 192c64.7 0 121.9-32 156.7-81L529 444.4c4.6 2.4 9.6 3.6 14.8 3.6l2 0c9 0 17.6-3.8 23.7-10.5l63.3-69.6c4.6-5.1 7.2-11.7 7.2-18.5c0-8.4-3.9-16.4-10.5-21.6l-127-100.4c-5.2-4.1-12.4-4.6-18.2-1.2l-19.3 11.6c-10.3 6.2-23.4 5.5-33-1.7c-9.7-7.3-14-19.8-10.8-31.5l6.5-24c1.7-6.2-.5-12.8-5.5-16.8l-69.8-55.2C322.4 84.8 286.4 70 248.6 65.5c-.6-.1-1.1-.1-1.7-.1c-7.5-.9-15.2-1.4-22.9-1.4c-38.8 0-74.8 11.5-105 31.2C107.8 76.5 87.4 64 64 64C28.7 64 0 92.7 0 128zM354.6 348.5C325.6 389.4 277.9 416 224 416c-88.4 0-160-71.6-160-160s71.6-160 160-160c6.5 0 12.9 .4 19.1 1.1c.8 .1 1.6 .2 2.3 .2c31.7 3.9 61.9 16.5 87.2 36.4l61.5 48.7-3.8 13.8c-6.6 24.4 2.3 50.3 22.5 65.5c20 15 47.2 16.4 68.6 3.5l9.9-5.9L606 349.9 545.8 416l-2 0L395.5 338.6c-14.2-7.4-31.6-3.2-40.9 9.9zM256 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWhistle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;